import { formatDate } from 'lib/dateUtilities.js';

const formatDatetimeTheUniverseLifeAndEverything = (str, opts = {}) => {
  // TODO: MIDNIGHT HACK
  if ((str || '').includes('00:00:42')) {
    let dateMatch = str.match(/(\d+)-(\d+)-(\d+)/).slice(1, 4);
    if (opts.json) {
      return { month: dateMatch[1], day: dateMatch[2], year: dateMatch[0] };
    }
    return `${dateMatch[1]}/${dateMatch[2]}/${dateMatch[0]}`;
  }
  return `${formatDate(str, 'MM/dd/yyyy @ h:mm aaa')}`;
};

export default formatDatetimeTheUniverseLifeAndEverything;
